import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function Form() {
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {};

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id;
    }

    const path = '/salaryequalities/';
    const paths = {
        endpointSave: config.endpoints.backend + 'documentations/save',
        endpointGetById: config.endpoints.backend + 'documentations/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllDocumenationCategories:
            config.endpoints.backend + 'documentationcategories/getall',
        endpointGetAllDocumentTypes:
            config.endpoints.backend + 'documenttypes/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleAdd: 'Nova Documentação - Igualdade Salarial',
        labelTitleEdit: 'Editar Documentação - Igualdade Salarial',
        labelTitleView: 'Visualizar Documentação - Igualdade Salarial'
    };

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'pdc_category_id',
                    type: 'select',
                    label: 'Categoria',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumenationCategories,
                        label: 'name',
                        value: 'id'
                    },
                    value: values.pdc_category_id
                        ? values.pdc_category_id
                        : null,
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                    readOnly: true
                },
                {
                    name: 'pdc_document_type_id',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumentTypes,
                        label: 'name',
                        value: 'id'
                    },
                    value: values.pdc_document_type_id
                        ? values.pdc_document_type_id
                        : null,
                    validations: {
                        required: true
                    },
                    readOnly: true,
                    columnSize: 6
                },
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    maxLength: 500,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'publish_date',
                    type: 'date',
                    label: 'Data de Publicação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_project_ids',
                    type: 'multiinput',
                    label: 'Projetos',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_project_id',
                            type: 'select',
                            label: 'Projeto',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjects,
                                label: 'project_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });
            }

            values.pdc_category_id =
                keys?.default_foreign_key?.pdc_documentation_categories?.salary_equality;
            values.pdc_document_type_id =
                keys?.default_foreign_key?.pdc_document_types?.salary_equality;

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Form;
